import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { requestGet } from '../../api/request';
import { parseDateTime } from '../Partials/Helper';
import { BreadcrumbComponent } from '../Partials/Breadcrumb';
import { EVENT_BY_ID, EVENT_FLICKER_IMAGES } from '../../api/url';
import Map from '../Home/Map';
import EventMore from '../Event/EventMore';
import GalleryTemplate from './GalleryTemplate';

const GalleryById = () => {
  const { galleryId } = useParams();
  const navigate = useNavigate();

  const dictionary = useSelector((state) => state.dictionaryReducer.dictionary);
  const currentLanguage = useSelector(
    (state) => state.languageReducer.current_language,
  );
  const fontSize = useSelector((state) => state.fontSizeReducer.font_size);

  const [loader, setLoader] = useState(false);
  const [pictures, setPictures] = useState(undefined);
  const [data, setData] = useState(null);

  const getData = async () => {
    setLoader(true);
    const response = await requestGet(EVENT_BY_ID, {
      'id': galleryId,
      'lang_id': currentLanguage.id,
    });
    if (response.success) {
      setLoader(false);
      setData(response.data);
    }
  };

  const getPictures = async () => {
    setLoader(true);
    const response = await requestGet(EVENT_FLICKER_IMAGES, {
      'id': galleryId,
      'lang_id': currentLanguage.id,
    });

    if (response.success) {
      setPictures(response.data);
      setLoader(false);
    }
  };

  const changeFontSize = (size) => {
    const select = document.querySelectorAll('.events-content *');
    for (let i = 0; i < select.length; i += 1) {
      const elem = select[i];
      elem.style.fontSize = `${parseInt(size, 10) - 4}px`;
    }
  };

  const shareButtons = () => {
    const shareButton = document.getElementById('share_button');
    const shareButtons = document.querySelector('.share_buttons');

    if (shareButton) {
      shareButton.addEventListener('click', () => {
        if (!shareButtons.classList.contains('active')) {
          shareButtons.classList.add('active');
        } else {
          shareButtons.classList.remove('active');
        }
      });
    }
  };

  const copyUrl = () => {
    const inputc = document.body.appendChild(document.createElement('input'));
    inputc.value = window.location.href;
    inputc.select();
    document.execCommand('copy');
    inputc.parentNode.removeChild(inputc);
    const button = document.getElementById('share_button');
    const oldText = button.innerHTML;

    button.innerHTML = dictionary.copied;
    const delayDebounceFn = setTimeout(() => {
      button.innerHTML = oldText;
    }, 2000);
    return () => clearTimeout(delayDebounceFn);
  };

  useEffect(() => {
    if (dictionary) {
      setPictures(undefined);
      setData(null);
      getData();
      getPictures();
    }
  }, [galleryId]);

  useEffect(() => {
    if (data) {
      navigate('/');
    }
  }, [currentLanguage]);

  useEffect(() => {
    changeFontSize(fontSize);
  });

  useEffect(() => {
    shareButtons();
  }, [data]);

  return (
    <section className="section">
      <div className="container">
        <div className="row">
          {loader === true ? (
            <div className="row d-flex justify-content-md-center align-items-center mt-3 mb-3">
              <div className="spinner-border text-success" role="status">
                <span className="sr-only" />
              </div>
            </div>
          ) : null}
          {data !== null ? (
            <div className="col-lg-9">
              <div className="breadcrumbs mt-4">
                <div className="breadcrumbs-container">
                  <BreadcrumbComponent />
                </div>
              </div>
              <div className="events-head">
                <div className="events-head__title">
                  <span>{data.title}</span>
                </div>
                <div className="events-head__info">
                  <div className="events-head__box">
                    <div className="events-head-date" />

                    <div className="events-head-time">
                      <span>{parseDateTime(data.publish_date)}</span>
                    </div>

                    <div className="events-head-location">
                      <span>
                        {data.city_relation.length > 0
                          ? data.city_relation.map((cityValue) => (
                            <span key={cityValue.id}>
                              {cityValue.city.name}
                            </span>
                          ))
                          : null}
                        {data.country_relation.length > 0
                          ? data.country_relation.map((countryValue) => (
                            <span key={countryValue.id}>
                              {' '}
                              {countryValue.country.name}
                            </span>
                          ))
                          : null}
                      </span>
                    </div>
                  </div>
                  <div className="events-head__mob">
                    <div className="events-head__item">
                      <div className="events-head-date">
                        <span>{parseDateTime(data.publish_date)}</span>
                      </div>
                    </div>
                    <div className="events-head__item">
                      <div className="saidbar-item__info">
                        <div className="saidbar-item__img" />
                        <div className="saidbar-item__count" />
                      </div>
                      <div className="saidbar-item__info">
                        <div className="saidbar-item__img" />
                        <div className="saidbar-item__count" />
                      </div>
                      <div className="saidbar-item__info ">
                        <div className="saidbar-item__img" />
                        <div className="saidbar-item__count" />
                      </div>
                    </div>
                  </div>

                  <div className="events-head__button">
                    <div className="share_buttons">
                      <ol>
                        <li>
                          <a
                            href={`https://twitter.com/intent/tweet?text=${data.title}&url=${window.location}`}
                            target="_blank"
                            rel="noreferrer"
                            title={dictionary.share_twitter}
                          >
                            <svg
                              className="social-svg-share"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle cx="12.0006" cy="12.0001" r="11.4542" />
                              <path d="M17.831 8.94342C17.8409 9.07705 17.8409 9.20992 17.8409 9.34279C17.8409 13.409 14.746 18.0946 9.08993 18.0946C7.34736 18.0946 5.7285 17.5898 4.36621 16.7132C4.61362 16.7414 4.85187 16.7514 5.10921 16.7514C6.49363 16.7547 7.83886 16.2918 8.92804 15.4372C8.28616 15.4256 7.66394 15.2138 7.14824 14.8314C6.63254 14.4491 6.24912 13.9152 6.05151 13.3044C6.24165 13.3327 6.43255 13.3518 6.63262 13.3518C6.90828 13.3518 7.18547 13.3136 7.44281 13.2471C6.74621 13.1065 6.11983 12.7289 5.67017 12.1786C5.22051 11.6283 4.97534 10.9392 4.97634 10.2286V10.1904C5.3864 10.4187 5.86213 10.5615 6.36612 10.5806C5.94391 10.3 5.59771 9.91934 5.35841 9.47244C5.1191 9.02555 4.99414 8.52638 4.99467 8.01945C4.99467 7.44826 5.14662 6.92442 5.41313 6.46778C6.18601 7.4185 7.14997 8.19627 8.24257 8.75073C9.33518 9.30519 10.5321 9.62396 11.7557 9.68642C11.7084 9.45733 11.6793 9.21985 11.6793 8.9816C11.6791 8.57762 11.7586 8.17756 11.9131 7.80429C12.0676 7.43102 12.2941 7.09186 12.5798 6.80621C12.8654 6.52055 13.2046 6.29399 13.5779 6.13949C13.9511 5.98498 14.3512 5.90556 14.7552 5.90576C15.641 5.90576 16.4405 6.27688 17.0025 6.87708C17.6911 6.74392 18.3515 6.49254 18.9543 6.13408C18.7248 6.84487 18.244 7.44758 17.6019 7.82931C18.2127 7.75965 18.8095 7.59904 19.3728 7.35281C18.9521 7.96607 18.4309 8.50384 17.831 8.94342Z" />
                            </svg>
                          </a>
                        </li>

                        <li>
                          <a
                            href={`http://www.facebook.com/sharer/sharer.php?u=${window.location}&t=${data.title}`}
                            target="_blank"
                            rel="noreferrer"
                            title={dictionary.share_facebook}
                          >
                            <svg
                              className="social-facebook-share"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M12 0.54541C5.67413 0.54541 0.54541 5.67413 0.54541 12C0.54541 17.7164 4.73362 22.4545 10.2106 23.3171V15.3118H7.30084V12H10.2106V9.47629C10.2106 6.60319 11.9209 5.01887 14.5363 5.01887C15.7895 5.01887 17.1024 5.24225 17.1024 5.24225V8.05921H15.6544C14.2338 8.05921 13.7894 8.94359 13.7894 9.84974V11.9977H16.9637L16.4563 15.3095H13.7894V23.3148C19.2663 22.4568 23.4545 17.7175 23.4545 12C23.4545 5.67413 18.3258 0.54541 12 0.54541Z" />
                            </svg>
                          </a>
                        </li>

                        <li>
                          <a
                            href=""
                            onClick={(e) => {
                              e.preventDefault();
                            }}
                            style={{ cursor: 'pointer' }}
                            title={dictionary.share_copyboard}
                          >
                            <svg
                              className="social-svg"
                              width="24"
                              height="24"
                              viewBox="0 1 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              onClick={copyUrl}
                            >
                              <path d="M24.6525 12.979C24.6525 15.3524 23.9487 17.6725 22.6301 19.6458C21.3115 21.6192 19.4374 23.1573 17.2447 24.0656C15.052 24.9738 12.6392 25.2114 10.3114 24.7484C7.98361 24.2854 5.84542 23.1425 4.16719 21.4643C2.48896 19.786 1.34607 17.6479 0.883048 15.3201C0.420025 12.9923 0.657665 10.5795 1.56592 8.3868C2.47417 6.19409 4.01224 4.31994 5.98563 3.00137C7.95902 1.68279 10.2791 0.979004 12.6525 0.979004C14.2283 0.979004 15.7888 1.28939 17.2447 1.89245C18.7006 2.49551 20.0234 3.37942 21.1377 4.49372C22.252 5.60802 23.136 6.93089 23.739 8.3868C24.3421 9.84271 24.6525 11.4031 24.6525 12.979ZM16.1204 12.3409V12.0226H12.3039C12.1976 12.0218 12.0959 11.9792 12.0207 11.9041C11.9455 11.8289 11.903 11.7272 11.9022 11.6209V7.82099H7.42928C7.30211 7.82099 7.18012 7.8714 7.09006 7.96118C7 8.05096 6.9492 8.17279 6.94879 8.29996V19.8377C6.9492 19.9648 7 20.0867 7.09006 20.1764C7.18012 20.2662 7.30211 20.3166 7.42928 20.3166H15.6415C15.7684 20.3162 15.89 20.2656 15.9797 20.1759C16.0695 20.0862 16.12 19.9646 16.1204 19.8377V12.3409ZM9.18146 6.62053H13.1754C13.4638 6.63981 13.7356 6.76252 13.9408 6.96612L14.1348 7.16013V5.58832H9.66043C9.53312 5.58872 9.41114 5.63947 9.32111 5.7295C9.23109 5.81952 9.18034 5.9415 9.17994 6.06881L9.18146 6.62053ZM13.0693 7.84372V10.86H16.1007L13.0693 7.84372ZM15.3004 8.62584H18.3334L15.302 5.61258L15.3004 8.62584ZM18.3531 10.1082V9.78991H16.7813L16.9738 9.98241C17.1716 10.1785 17.2949 10.4374 17.3224 10.7145V18.0855H17.8741C18.0013 18.0851 18.1231 18.0343 18.2129 17.9442C18.3027 17.8541 18.3531 17.7322 18.3531 17.605V10.1082Z" fill="#3B6B3B" />
                            </svg>
                          </a>
                        </li>
                      </ol>
                    </div>
                    <div id="share_button" className="button button-update">
                      {dictionary.share}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row" style={{ display: 'flex' }}>
                {typeof pictures !== 'undefined' ? (
                  <GalleryTemplate
                    galleryID="gallery"
                    images={pictures}
                  />
                ) : null}
              </div>
            </div>
          ) : null}
          <div className="col-lg-3 pl-lg-4 mt-4 d-none d-lg-block">
            <div className="saidbar">
              <div className="saidbar-content">
                <EventMore />
              </div>
            </div>
          </div>
          <Map />
        </div>
      </div>
    </section>
  );
};

export default GalleryById;
